import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHandler,HttpHeaders  } from '@angular/common/http';
// import * as AppConst from '../app.config';
import { catchError, map } from 'rxjs/operators';
import { Observable, pipe, throwError } from 'rxjs';
// import { environment } from 'src/environments/environment';
import { DOCUMENT } from '@angular/common';
import { ConfigService } from './config.service';


@Injectable({
  providedIn: "root",
})
export class HttpService {
  session: string;
  constructor(private http: HttpClient, @Inject(DOCUMENT) private document: Document, private configService: ConfigService) {
    this.session = this.document.location.hostname;
  }

  getSession64(){
    return btoa(this.session);
  }

  // ส่งข้อมูลแบบ Get method
  requestGet(url: string): Observable<any> {
    return this.http
      .get<any>(`${this.configService.config.dist}${url}`,{
        headers: this.appendHeaders(this.session)
      })
      .pipe(catchError((err) => this.handelError(err)));
  }

  requestGet2(url: string): Observable<any> {
    return this.http
      .get<any>(`${url}`,{
        headers: this.appendHeaders(this.session)
      })
      .pipe(catchError((err) => this.handelError(err)));
  }

  // ส่งข้อมูลแบบ Post methoddistricts
  requestPost(url: string, body: any, accessToken?: string) {
    return this.http
      .post(`${this.configService.config.dist}${url}`, body, {
        headers: this.appendHeaders(this.session)
      })
      .pipe(catchError((err) => this.handelError(err)));
  }

  // ส่งข้อมูลแบบ Delete method
  requestDelete(url: string, accessToken?: string) {
    return this.http
      .delete(`${this.configService.config.dist}${url}`, {
        headers: this.appendHeaders(this.session)
      })
      .pipe(catchError((err) => this.handelError(err)));
  }

  // ส่งข้อมูลแบบ Put method
  requestPut(url: string, body: any, accessToken?: string) {
    return this.http
      .put(`${this.configService.config.dist}${url}`, body, {
        headers: this.appendHeaders(this.session)
      })
      .pipe(catchError((err) => this.handelError(err)));
  }

  requestFile(url: string): Observable<Blob> {
    return this.http
      .get(`${this.configService.config.dist}${url}`, {
        responseType: "blob",
        headers: this.appendHeaders(this.session)
      })
      .pipe(catchError((err) => this.handelError(err)));
  }

  requestFilePost(url: string,body:any): Observable<Blob> {
    return this.http
      .post(`${this.configService.config.dist}${url}`,body, {
        responseType: "blob",
        headers: this.appendHeaders(this.session)
      })
      .pipe(catchError((err) => this.handelError(err)));
  }

  requestFile2(url: string): Observable<Blob> {
    return this.http
      .get(`${this.configService.config.report}${url}`, { responseType: "blob",
        headers: this.appendHeaders(this.session)
       })
      .pipe(catchError((err) => this.handelError(err)));
  }

  private handelError(err: HttpErrorResponse): Observable<any> {
    if (err.error instanceof ErrorEvent) {
      return throwError(err);
    } else {
      return throwError(err);
    }
  }

  getSpecial(){
    const url = `${this.configService.config.dist}getConnection`;
    let re = false;
    return this.http.get(url);
  }

  private appendHeaders(session) {
    const headers = {};
    if (session) headers['session'] = `${session}`;
    return new HttpHeaders(headers);
  }
  
}

